import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Menu from './menu.vue'
    import LoginMessage from './loginMessage.vue'
    import { toRefs } from 'vue'
    
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
      fixedNobanner: Boolean
    },
  setup(__props) {

    const props = __props

    const {fixedNobanner} = toRefs(props)



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["t2-header", {'fixed_nobanner':_unref(fixedNobanner)}])
  }, [
    _createVNode(LoginMessage),
    _createVNode(Menu)
  ], 2))
}
}

})